import { render, staticRenderFns } from "./Openclass.vue?vue&type=template&id=49d1cca8&scoped=true&"
import script from "./Openclass.vue?vue&type=script&lang=js&"
export * from "./Openclass.vue?vue&type=script&lang=js&"
import style0 from "./Openclass.vue?vue&type=style&index=0&id=49d1cca8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49d1cca8",
  null
  
)

export default component.exports